import { ViewportRuler } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cs-full-page-layout',
  standalone: false,
  template: `
    <div #ref [class.h-100]="type === 'contain'">
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./full-page-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullPageLayoutComponent implements OnInit, OnDestroy {
  private sub: Subscription;

  @Input()
  public type: 'contain' | 'overflow' = 'overflow';
  @Input()
  public enableBoxShadow: boolean = false;

  @ViewChild('ref', { read: ElementRef, static: true })
  private divElementRef: ElementRef;

  constructor(
    private viewPortRuler: ViewportRuler,
    private renderer: Renderer2,
    private compElemRef: ElementRef
  ) {}

  public ngOnInit(): void {
    this.updateView();
    this.sub = this.viewPortRuler.change().subscribe(_ => {
      this.updateView();
    });
  }

  public updateView(): void {
    const { height } = this.viewPortRuler.getViewportRect();
    if (this.enableBoxShadow) {
      this.renderer.addClass(this.divElementRef.nativeElement, 'box-shadow');
    } else {
      this.renderer.removeClass(this.divElementRef.nativeElement, 'box-shadow');
    }
    if (this.type === 'overflow') {
      this.renderer.setStyle(
        this.compElemRef.nativeElement,
        'paddingTop',
        '16px'
      );
      this.renderer.setStyle(
        this.compElemRef.nativeElement,
        'minHeight',
        `${height - 62}px`
      );
    } else if (this.type === 'contain') {
      this.renderer.setStyle(
        this.compElemRef.nativeElement,
        'padding',
        '16px 0'
      );
      this.renderer.setStyle(
        this.compElemRef.nativeElement,
        'height',
        `${height - 62}px`
      );
    }
  }

  public ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
